import { Component, OnInit } from '@angular/core';
import { CommonServiceService } from '../services/common-service.service';

@Component({
  selector: 'app-ourpartners',
  templateUrl: './ourpartners.component.html',
  styleUrls: ['./ourpartners.component.scss']
})
export class OurpartnersComponent implements OnInit {

  ourPartners: any = [];
  constructor(private commonService: CommonServiceService) { }

  get pageHero(): any {
    return this.ourPartners && this.ourPartners.length ? this.ourPartners[0] : null;
  }

  get pageTitle(): string {
    return (this.pageHero && this.pageHero.title) || 'Our Partners';
  }

  ngOnInit(): void {
    this.getOurPartnerData();
  }

  getOurPartnerData(): void {
    this.commonService.ourPartnerPageData().subscribe((res: any) => {
      this.ourPartners = res?.data ?? [];
    });
  }
  stripHtmlTagsForCard(input: any,limit:number): string {
    const doc: any = new DOMParser().parseFromString(input, 'text/html');
  
    // Extract plain text content without HTML tags
    const textContent = doc.body.textContent || "";
  
    // Truncate text content to a limit of 150 characters
    let truncatedText :string = ''
    if(limit > 0){
      truncatedText  = textContent.length > limit ? textContent.substring(0, limit) + '...' : textContent;
    }
    else{
      truncatedText = textContent;
    }
   
    return truncatedText;
  }
}
